package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.StyleW500Rounded: ImageVector
    get() {
        if (_styleW500Rounded != null) {
            return _styleW500Rounded!!
        }
        _styleW500Rounded = Builder(name = "StyleW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(150.87f, 794.87f)
                lineToRelative(-34.0f, -14.0f)
                quadToRelative(-31.0f, -13.0f, -41.5f, -45.0f)
                reflectiveQuadToRelative(3.5f, -63.0f)
                lineToRelative(72.0f, -156.0f)
                verticalLineToRelative(278.0f)
                close()
                moveTo(310.87f, 882.87f)
                quadToRelative(-33.0f, 0.0f, -56.5f, -23.5f)
                reflectiveQuadToRelative(-23.5f, -56.5f)
                verticalLineToRelative(-240.0f)
                lineToRelative(106.0f, 294.0f)
                quadToRelative(3.0f, 7.0f, 6.0f, 13.5f)
                reflectiveQuadToRelative(8.0f, 12.5f)
                horizontalLineToRelative(-40.0f)
                close()
                moveTo(527.39f, 883.65f)
                quadToRelative(-35.11f, 13.2f, -68.22f, -3.12f)
                quadToRelative(-33.1f, -16.31f, -46.3f, -51.66f)
                lineToRelative(-178.0f, -488.0f)
                quadToRelative(-13.2f, -35.11f, 2.12f, -68.6f)
                quadToRelative(15.31f, -33.49f, 50.42f, -45.92f)
                lineToRelative(302.0f, -110.0f)
                quadToRelative(35.11f, -12.96f, 68.34f, 3.24f)
                quadToRelative(33.23f, 16.19f, 46.42f, 51.54f)
                lineToRelative(178.0f, 488.24f)
                quadToRelative(12.96f, 35.11f, -2.59f, 68.48f)
                quadToRelative(-15.56f, 33.37f, -50.67f, 45.8f)
                lineToRelative(-301.52f, 110.0f)
                close()
                moveTo(475.39f, 394.36f)
                quadToRelative(12.7f, -12.58f, 12.7f, -31.01f)
                quadToRelative(0.0f, -18.44f, -12.7f, -31.13f)
                quadToRelative(-12.69f, -12.7f, -31.13f, -12.7f)
                quadToRelative(-18.43f, 0.0f, -31.01f, 12.7f)
                quadToRelative(-12.58f, 12.69f, -12.58f, 31.13f)
                quadToRelative(0.0f, 18.43f, 12.58f, 31.01f)
                quadToRelative(12.58f, 12.57f, 31.01f, 12.57f)
                quadToRelative(18.44f, 0.0f, 31.13f, -12.57f)
                close()
                moveTo(498.2f, 796.41f)
                lineTo(794.7f, 688.09f)
                lineTo(618.61f, 203.59f)
                lineTo(322.11f, 311.91f)
                lineTo(498.2f, 796.41f)
                close()
                moveTo(322.11f, 311.91f)
                lineTo(618.61f, 203.59f)
                lineTo(322.11f, 311.91f)
                close()
            }
        }
        .build()
        return _styleW500Rounded!!
    }

private var _styleW500Rounded: ImageVector? = null
